// src/app/components/sig-tracker/sig-tracker.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface CountyProgress {
  name: string;
  collected: number;
  goal: number;
  captain?: string;
}

@Component({
  selector: 'app-sig-tracker',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sig-tracker.component.html',
  styleUrls: ['./sig-tracker.component.css'],
})
export class SigTrackerComponent {
  totalGoal = 25000;
  totalCollected = 8000;

  // Update these numbers as doors get knocked.
  // Goal per county = rough proportional share of 25,000.
  counties: CountyProgress[] = [
    { name: 'Wayne',          collected: 1750,  goal: 2200, captain: 'Detroit Collector (needs more)' },
{ name: 'Oakland',        collected: 800,  goal: 1600 },
{ name: 'Macomb',         collected: 550,  goal: 1100, captain: 'County Captain' },
{ name: 'Kent',           collected: 450,  goal: 800 },
{ name: 'Washtenaw',      collected: 350,  goal: 500 },
{ name: 'Ingham',         collected: 260,  goal: 450 },
{ name: 'Ottawa',         collected: 150,  goal: 400 },
{ name: 'Genesee',        collected: 375,  goal: 500, captain: 'County Captain' },
{ name: 'Kalamazoo',      collected: 150,  goal: 350 },
{ name: 'Saginaw',       collected: 100,  goal: 300 },
{ name: 'Muskegon',       collected: 75,   goal: 250 },
{ name: 'Jackson',        collected: 75,   goal: 200 },
{ name: 'Livingston',     collected: 100,  goal: 250 },
{ name: 'Bay',            collected: 50,   goal: 180 },
{ name: 'Berrien',        collected: 50,   goal: 180 },
{ name: 'Calhoun',        collected: 50,   goal: 180 },

{ name: 'Marquette',      collected: 1250,  goal: 2220 },
{ name: 'Gogebic',        collected: 450,  goal: 80,  captain: 'Lydia HQ' },
{ name: 'Iron',           collected: 25,   goal: 60 },
{ name: 'Ontonagon',      collected: 10,   goal: 40 },
{ name: 'Houghton',       collected: 25,   goal: 80 },
{ name: 'Keweenaw',       collected: 0,    goal: 20 },
{ name: 'Baraga',         collected: 25,   goal: 30 },
{ name: 'Dickinson',      collected: 25,   goal: 50 },
{ name: 'Menominee',      collected: 200,  goal: 50 },
{ name: 'Alger',          collected: 0,    goal: 30 },
{ name: 'Schoolcraft',    collected: 0,    goal: 30 },
{ name: 'Luce',           collected: 25,   goal: 25 },
{ name: 'Chippewa',       collected: 10,   goal: 70 },
{ name: 'Mackinac',       collected: 10,   goal: 40 },

{ name: 'Emmet',          collected: 25,   goal: 60 },
{ name: 'Cheboygan',      collected: 200,  goal: 1000 },
{ name: 'Charlevoix',     collected: 0,    goal: 50 },
{ name: 'Antrim',         collected: 10,   goal: 40 },
{ name: 'Otsego',         collected: 0,    goal: 40 },
{ name: 'Montmorency',    collected: 0,    goal: 25 },
{ name: 'Alpena',         collected: 200,  goal: 50, captain: 'County Captain' },
{ name: 'Presque Isle',   collected: 0,    goal: 25 },
{ name: 'Crawford',       collected: 10,   goal: 25 },
{ name: 'Oscoda',         collected: 25,   goal: 20, captain: 'County Captain' },
{ name: 'Alcona',         collected: 0,    goal: 25 },
{ name: 'Iosco',          collected: 10,   goal: 50 },
{ name: 'Arenac',         collected: 0,    goal: 25 },
{ name: 'Gladwin',        collected: 0,    goal: 25 },
{ name: 'Clare',          collected: 10,   goal: 30 },
{ name: 'Roscommon',      collected: 0,    goal: 30 },
{ name: 'Missaukee',      collected: 0,    goal: 20 },
{ name: 'Wexford',        collected: 10,   goal: 40 },
{ name: 'Osceola',        collected: 0,    goal: 25 },
{ name: 'Mecosta',        collected: 10,   goal: 30 },
{ name: 'Isabella',       collected: 0,    goal: 60 },
{ name: 'Midland',        collected: 100,  goal: 80, captain: 'County Captain' },
{ name: 'Huron',          collected: 50,   goal: 50, captain: 'County Captain' },
{ name: 'Tuscola',        collected: 0,    goal: 50 },
{ name: 'Sanilac',        collected: 10,   goal: 40 },

{ name: 'St. Clair',      collected: 1110, goal: 2000, captain: 'Port Huron Collector' },
{ name: 'Lapeer',         collected: 25,   goal: 100 },
{ name: 'Shiawassee',     collected: 10,   goal: 70 },
{ name: 'Clinton',        collected: 25,   goal: 80 },
{ name: 'Eaton',          collected: 25,   goal: 100 },
{ name: 'Barry',          collected: 0,    goal: 50 },
{ name: 'Ionia',          collected: 10,   goal: 50 },
{ name: 'Montcalm',       collected: 0,    goal: 40 },
{ name: 'Newaygo',        collected: 10,   goal: 40 },
{ name: 'Mason',          collected: 0,    goal: 40 },
{ name: 'Lake',           collected: 0,    goal: 20 },
{ name: 'Oceana',         collected: 10,   goal: 30 },
{ name: 'Manistee',       collected: 10,   goal: 30 },
{ name: 'Benzie',         collected: 0,    goal: 30 },
{ name: 'Leelanau',       collected: 10,   goal: 40 },
{ name: 'Grand Traverse', collected: 500,  goal: 1150 },

{ name: 'Kalkaska',       collected: 10,   goal: 25 },
{ name: 'Allegan',        collected: 25,   goal: 120 },
{ name: 'Van Buren',      collected: 25,   goal: 80 },
{ name: 'St. Joseph',     collected: 25,   goal: 60, captain: 'County Captain' },
{ name: 'Branch',         collected: 0,    goal: 40 },
{ name: 'Hillsdale',      collected: 10,   goal: 40 },
{ name: 'Lenawee',        collected: 25,   goal: 80 },
{ name: 'Monroe',         collected: 75,   goal: 150 },
  ];

  get percentComplete(): number {
    return Math.min(100, Math.round((this.totalCollected / this.totalGoal) * 100));
  }

  get countiesWithCaptain(): number {
    return this.counties.filter(c => c.captain).length;
  }

  get countiesWithProgress(): CountyProgress[] {
    return this.counties
      .filter(c => c.collected > 0)
      .sort((a, b) => b.collected - a.collected);
  }

  get countiesNeedingCaptains(): CountyProgress[] {
    return this.counties
      .filter(c => !c.captain && c.collected === 0)
      .sort((a, b) => b.goal - a.goal)
      .slice(0, 10);
  }

  pct(c: CountyProgress): number {
    return Math.min(100, Math.round((c.collected / c.goal) * 100));
  }
}
